module.exports = __webpack_public_path__ + "media/img/icon2-5064ced5d812f8b74fc68cd0cd307a5f.svg";